// extracted by mini-css-extract-plugin
module.exports = {"yearHeaderFilter":"year-module--yearHeaderFilter--wWzX8","fromTo":"year-module--fromTo--3a7zY","col":"year-module--col--1BdJw","separator":"year-module--separator--1_aBY"};